module.exports = __webpack_public_path__ + "img/andir.6ad0d07.svg";